import { lazyTree } from '@/api/v4ward/clientserve/repository';
export default {
  submitText: '提交',
  emptyBtn: false,
  group: [
    {
      prop: 'group',
      column: [
        {
          label: '上级目录',
          prop: 'parentId',
          type: 'tree',
          lazy: true,
          dicData: [],
          props: {
            labelText: '标题',
            label: 'nodeName',
            value: 'id',
            children: 'children',
          },
          treeLoad: function (node, resolve) {
            const id = node.level === 0 ? 0 : node.data.id;
            lazyTree(id).then((res) => {
              resolve(
                res.data.map((item) => {
                  return {
                    ...item,
                    leaf: !item.hasChildren,
                  };
                })
              );
            });
          },
        },
        {
          label: '目录名称',
          prop: 'nodeName',
          rules: [
            {
              required: true,
              message: '请输入目录名称',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '排序号',
          prop: 'indexNum',
          maxlength: 8,
          showWordLimit: true,
          rules: [
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
            {
              required: true,
              message: '请输入排序号',
              trigger: 'blur',
            },
          ],
        },
      ],
    },
  ],
};
